


import React from 'react';
import { useTranslation } from 'react-i18next'; // For language handling

function KSA_Natioanl_Geospatial_Governance() {
  const { t } = useTranslation(); // Hook for translation

  return (
    <div className="pdf-page">
  <iframe
    src={t('Digital_Library_Gov_docpdf')}
    title="PDF Document"
  />
</div>

  );
};

export default KSA_Natioanl_Geospatial_Governance;
